import {
  Accordion,
  AccordionDetails,
  Box,
  Button,
  Typography,
  styled as muiStyled,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { abyssColors } from '@/theme/colors';

export const EquipmentName = muiStyled(Typography)(() => ({
  color: abyssColors.primary[700],
  fontSize: '2.4rem',
  fontWeight: 700,
}));

export const LineBreak = muiStyled(Box)(() => ({
  height: '26px',
  width: '1px',
  margin: '0 16px',
  backgroundColor: abyssColors.primary[300],
  opacity: 0.2,
}));

export const EquipmentButton = muiStyled(Button)(() => ({
  padding: '4px 8px',
  borderRadius: '4px',
  border: `1px solid ${abyssColors.primary[500]}`,
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 600,
  textTransform: 'none',
  lineHeight: '16px',
  height: 'auto',
}));

export const DetailsAccordian = muiStyled(Accordion)(() => ({
  boxShadow: 'none',
  padding: '0px',
  margin: '0px',
  '&::before': {
    opacity: 0,
  },
}));

export const DetailsPanel = muiStyled(AccordionDetails)(() => ({
  padding: '0px',
  paddingTop: '8px',
  marginLeft: '8px',
}));

export const Detail = muiStyled(Box)(() => ({
  marginRight: '24px',
  gap: '4px',
  display: 'flex',
  alignItems: 'center',
}));

export const EquipmentLabel = muiStyled(Typography)(() => ({
  color: abyssColors.primary[400],
  fontSize: '1.2rem',
}));

export const EquipmentValue = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 500,
}));

interface FlipProps {
  flipVertical: boolean;
}

export const DropDownIcon = muiStyled(ArrowDropDown)(({ flipVertical }: FlipProps) => ({
  fontSize: '2rem',
  transform: `rotate(${flipVertical ? '180deg' : '0deg'})`,
}));
